const _keyColors = [
    [119, 255, 119],
    [0, 204, 187],
    [0, 153, 255],
    [153, 102, 255],
    [255, 119, 119],
], _updateRouteColors = (route) => {
    const segmentCount = route.c();
    let index = 0, currentPoint = route.s(), currentLine = currentPoint.ol();
    while (currentLine) {
        const colorStr = _colorAt(index, segmentCount);
        currentLine.ml().setStyle({ color: colorStr });
        currentPoint = currentLine.ep();
        currentLine = currentPoint.ol();
        ++index;
    }
}, _colorAt = (index, count) => {
    const position = _positionOnRoute(index, count), [r, g, b] = _colorAtPositionOnRoute(position);
    return `rgb(${r}, ${g}, ${b})`;
}, _positionOnRoute = (index, count) => (index + 0.5) / count, _colorAtPositionOnRoute = (position) => (position < 0.2 ?
    _interpolateColors(_keyColors[0], _keyColors[1], position * 5) :
    position < 0.4 ?
        _interpolateColors(_keyColors[1], _keyColors[2], (position - 0.2) * 5) :
        position < 0.7 ?
            _interpolateColors(_keyColors[2], _keyColors[3], (position - 0.4) * 10 / 3) :
            _interpolateColors(_keyColors[3], _keyColors[4], (position - 0.7) * 10 / 3)), _interpolateColors = (colorA, colorB, position) => [
    _interpolateChannel(colorA, colorB, position, 0),
    _interpolateChannel(colorA, colorB, position, 1),
    _interpolateChannel(colorA, colorB, position, 2),
], _interpolateChannel = (colorA, colorB, position, index) => {
    const channelA = colorA[index], channelB = colorB[index], rawInterpolation = channelA * (1 - position) + channelB * position;
    return Math.ceil(rawInterpolation);
};
export { _updateRouteColors, };
